import axios from './axios'

function service(endpoint) {

    function owners() {
        return axios.get(`${endpoint}`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        owners
    }
}

export default service
